<template>
    <div>
        <b-row>
            <b-col sm="12" md="3">
                <b-form-group>
                    <strong>
                        <label>Filtro por Tipo da Contratação</label>
                    </strong>
                    <b-form-select
                        :options="tiposContratacao"
                        v-model="tipoContratacao"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <strong>
                        <label>Filtro por Natureza</label>
                    </strong>
                    <b-form-select
                        :options="naturezas"
                        v-model="natureza"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <strong>
                        <label>Filtro por Modulo</label>
                    </strong>
                    <b-form-select
                        :options="modulos"
                        v-model="modulo"
                    ></b-form-select>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="3">
                <b-form-group>
                    <strong>
                        <label>Filtro por Solução</label>
                    </strong>
                    <b-form-select
                        :options="solucoes"
                        v-model="codSolucao"
                        text-field="descricao"
                        value-field="codigo"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="2">
                <b-form-group>
                    <strong>
                        <label>Data Inícial das Etapas</label>
                    </strong>
                    <date-picker
                        ref="dp01"
                        v-model="dataInicial"
                        v-mask="'##/##/####'"
                        :config="$datePickerOptions2"
                        placeholder="Informe a data inicial das etapas"
                    ></date-picker>
                </b-form-group>    
            </b-col>
            <b-col sm="12" md="2">
                <b-form-group>
                    <strong>
                        <label>Data Final das Etapas</label>
                    </strong>
                    <date-picker
                        ref="dp02"
                        v-model="dataFinal"
                        v-mask="'##/##/####'"
                        :config="$datePickerOptions2"
                        placeholder="Informe a data final"
                    ></date-picker>
                </b-form-group>    
            </b-col>
        </b-row>
    </div>
</template>

<script>

export default {
    props: {
        servicos: {
            type: Object
        }
    },

    data() {
        return {
            naturezas: [
                'TODAS',
                'INSTRUTORIA',
                'CONSULTORIA'
            ],
            tiposContratacao: [
                'TODAS',
                'RODÍZIO',
                'ESCOLHA DO CLIENTE'
            ],
            modulos: [
                "TODOS",
                "SEBRAETEC",
                "SGF",
                "SOL"
            ],
            solucoes: [],
            dataInicial: this.$moment(new Date())
                .startOf('year')
                .format('DD/MM/YYYY'),
            dataFinal: this.$moment(new Date())
                .endOf('year')
                .format('DD/MM/YYYY'),
            tipoContratacao: 'TODAS',
            natureza: 'TODAS',
            modulo: "TODOS",
            codSolucao: 0,
        }
    },

    methods: {
        atualizarFiltro() {
            let filtrosDto = { 
                dataInicial: this.dataInicial
                    ? this.$moment(this.dataInicial, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : '',
                dataFinal: this.dataFinal
                    ? this.$moment(this.dataFinal, 'DD/MM/YYYY').format(
                          'YYYY-MM-DD'
                      )
                    : '',
                natureza: this.natureza,
                tipoContratacao: this.tipoContratacao,
                codSolucao: this.codSolucao,
                modulo: this.modulo
            }
            this.$emit('atualizarFiltro', filtrosDto)
        },

        obterSolucoes() {
            let antigoCodSolucao = this.codSolucao

            if (this.modulo == "TODOS") {
                this.solucoes = [{
                    codigo: 0,
                    descricao: 'TODAS'
                }]
                this.codSolucao = 0 
            } else {
                this.$store.dispatch('addRequest')
                this.servicos.obterSolucoes(this.modulo).then(response => {
                    if (response) {
                        if (response.success) {
                            this.solucoes = response.data
                            this.solucoes.unshift({
                                codigo: 0,
                                descricao: 'TODAS'
                            })
                            this.codSolucao = 0 
                        } else {
                            this.$toast.error(
                                response.errors[0],
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
            }

            if (antigoCodSolucao == 0) {
                this.atualizarFiltro()
            }  
        },
    },
    
    mounted() {
        this.obterSolucoes()
    },

    watch: {
        modulo(){
            this.obterSolucoes()
        },

        codSolucao() {
            this.atualizarFiltro()
        },
        
        natureza() {
            this.atualizarFiltro()
        },

        tipoContratacao() {
            this.atualizarFiltro()
        },

        dataInicial() {
            this.atualizarFiltro()
        },
        
        dataFinal() {
            this.atualizarFiltro()
        }
    }

}

</script>